import waja from 'waja';
import alert from 'alert';

const methods = {
	cancel (order, extraData, callback) {
		waja.post('order/' + order.id + '/cancel')
			.data(extraData)
			.on('success', res => {
				if (! res.data.success) {
					alert('Det gick inte att avbeställa ordern');
					return;
				}
				if (callback)
					callback();
				alert('Ordern har avbeställts!');
			}).on('400', res => {
				alert('Denna order är bindande och går inte att avbeställa. Vänligen kontakta kundtjänst om du tror att detta är fel.');
			}).go();
	},
};

export default methods;
